import React, { useState } from 'react';
import Styles from './EnergiaSolarBanner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function EnergiaSolarBanner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="energia-solar-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-320.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-320.png" />
                  <img
                    src="assets/energia-solar/hero/banner-320.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-450.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-450.png" />
                  <img
                    src="assets/energia-solar/hero/banner-450.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 450 && width <= 800 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-800.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-800.png" />
                  <img
                    src="assets/energia-solar/hero/banner-800.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 800 && width <= 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-992.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-992.png" />
                  <img
                    src="assets/energia-solar/hero/banner-992.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 992 && width <= 1280 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-1280.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-1280.png" />
                  <img
                    src="assets/energia-solar/hero/banner-1280.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-1360.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-1360.png" />
                  <img
                    src="assets/energia-solar/hero/banner-1360.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 1360 && width <= 1440 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-1440.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-1440.png" />
                  <img
                    src="assets/energia-solar/hero/banner-1440.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 1440 && width <= 1920 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-1920.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-1920.png" />
                  <img
                    src="assets/energia-solar/hero/banner-1920.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
              {width > 1920 && (
                <picture>
                  <source type="image/webp" srcSet="assets/energia-solar/hero/banner-2650.webp" />
                  <source type="image/png" srcSet="assets/energia-solar/hero/banner-2650.png" />
                  <img
                    src="assets/energia-solar/hero/banner-2650.png"
                    alt="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Financiamento de energia solar Santander</h1>
              <p className="alt-text">
                Financie seu projeto de energia solar em até <b>96 meses</b>. Faça uma simulação,
                encontre uma loja credenciada para realizar seu projeto e descubra as condições
                disponíveis para você.
              </p>
              <WhiteButton href="#form-energia-solar" className="btn-simulate">
                Simular agora
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default EnergiaSolarBanner;
